import RestService from './RestService';

export default class Webhooks extends RestService {
    constructor(parentService, companyId) {
        if (parentService && companyId)
            super(`${parentService.baseUrl}/${companyId}/webhooks`);
        else throw new Error('company is required');
    }
}
